module.exports = __webpack_public_path__ + "media/assets/images/smart_working/3-4-9caccb73482efe87f0b01dfd795cfe5a.png";